import { KeyValue } from '@/main/models/common';
import { CompanyFilterRequest } from '@/main/models/request';
import {
  CompanyBranchTypes,
  CompanyBranchActionTypes
} from './companyBranchTypes';

export function getCompanyBranch(
  request: CompanyFilterRequest
): CompanyBranchActionTypes {
  return {
    type: CompanyBranchTypes.GET_COMPANY_BRANCH,
    payload: { request }
  };
}

export function saveCompanyBranch(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): CompanyBranchActionTypes {
  return {
    type: CompanyBranchTypes.SAVE_COMPANY_BRANCH,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerCompanyBranch(): CompanyBranchActionTypes {
  return {
    type: CompanyBranchTypes.RESET_REDUCER_COMPANY_BRANCH
  };
}
